// extracted by mini-css-extract-plugin
export default {"plan":"Plan_plan__9zufr","circle":"Plan_circle__Rdh01"};